import { NgModule, ErrorHandler } from '@angular/core';

import { ErrorsHandler } from './errors-handler/errors-handler';
import { ErrorsService } from './errors-service/errors.service';

// Providers only: ErrorsComponent is standalone and lazy (see error-page-routes.ts).
@NgModule({
    providers: [
        ErrorsService,
        {
            provide: ErrorHandler,
            useClass: ErrorsHandler,
        },
    ],
})
export class ErrorsModule {}
